<template>
    <div id="controlling">
        <div id="main-view">
            // load Graph HTML or some Examples
        </div>
        <InteractionBar :interactions="interactions">
            <template v-slot:main>
                <div class="main-interaction">Hier wählst du die Apotheken aus</div>
                <div class="main-interaction">
                    <label>
                        Start-Datum
                        <br />
                        <b-form-datepicker
                            v-model="selectedStartDate"
                            :min="min"
                            :max="max"
                            locale="de"
                        ></b-form-datepicker>
                    </label>
                </div>
                <div class="main-interaction">
                    <label>
                        End-Datum
                        <br />
                        <b-form-datepicker
                            v-model="selectedEndDate"
                            :min="min"
                            :max="max"
                            locale="de"
                        ></b-form-datepicker>
                    </label>
                </div>
            </template>
            <template v-slot:graphType>
                Pie Chart / Line Chart / Was weiß ich
            </template>
            <template v-slot:save>
                Und ich bin ein Filter
            </template>
        </InteractionBar>
    </div>
</template>

<script>
import { DataV2API } from "@/store/api/Endpoints";
import Data from "@/store/api/data/Data";
import InteractionBar from "@/views/shared/widgets/InteractionBar";
export default {
    name: "Controlling",
    components: { InteractionBar },
    data() {
        return {
            interactions: { graphType: "Graph", save: "Export" },
            availableCombinations: {},

            /* Stuff concerning Date */
            max: new Date(),
            selectedStartDate: {},
            selectedEndDate: {}
        };
    },
    created() {
        // load availability matrix
        Data.getAvailable().then(result => {
            this.availableCombinations = result.data;
        });
    },
    methods: {
        dateDisabled(ymd, date) {
            // Return `true` if the date should be disabled
            if (date >= new Date()) {
                // Return `true` if the date should be disabled
                return true;
            }
        },
        load() {
            DataV2API.get().then(res => {});
        }
    }
};
</script>

<style scoped lang="scss">
#controlling {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
#main-view {
    background: white;
    box-shadow: inset 0 0 18px -2px $gray;
    padding: 12px;
    flex: 1;
    overflow-y: auto;
}
.main-interaction {
    display: flex;
    align-items: center;
    margin: 12px;
    color: white;
}
</style>
